const urlEncodeB64 = (input) => {
    const b64Chars = {
        '+': '-',
        '/': '_',
        '=': '',
    };
    return input.replace(/[+/=]/g, (m) => b64Chars[m]);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const sha256 = async (s) => {
    const digestOp = getCryptoSubtle().digest({ name: 'SHA-256' }, new TextEncoder().encode(s));
    if (window.msCrypto) {
        return new Promise((res, rej) => {
            digestOp.oncomplete = (e) => {
                res(e.target.result);
            };
            digestOp.onerror = (e) => {
                rej(e.error);
            };
            digestOp.onabort = () => {
                rej('The digest operation was aborted');
            };
        });
    }
    return digestOp;
};
const getCrypto = () => {
    return window.crypto || window.msCrypto;
};
export const getCryptoSubtle = () => {
    const crypto = getCrypto();
    return crypto.subtle || crypto.webkitSubtle;
};
/* eslint-enable @typescript-eslint/no-explicit-any */
export const createRandomString = (charsCount = 43) => {
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_';
    let random = '';
    const randomValues = Array.from(getCrypto().getRandomValues(new Uint8Array(charsCount)));
    randomValues.forEach(v => (random += charset[v % charset.length]));
    return random;
};
export const bufferToBase64UrlEncoded = (input) => {
    const ie11SafeInput = new Uint8Array(input);
    return urlEncodeB64(window.btoa(String.fromCharCode(...Array.from(ie11SafeInput))));
};
export const encode = (value) => btoa(value);
export const decode = (value) => atob(value);
